var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mg-participants-view"},[_c('participants',_vm._b({attrs:{"pageView":""}},'participants',_vm.meeting,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }